<template>
  <div>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="mb-3 card p-4" style="height: 70vh">
            <div class="d-flex justify-content-between align-items-center">
              <h2>Expiring Terminals | {{ dataValue == '365'? `91-${dataValue}` : dataValue}} days</h2>
              <div class="input-group mb-3" style="width: 25%;">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-search"></i></span>
                </div>
                <input
                  type="text"
                  v-model="searchTerm"
                  @keydown.enter="query"
                  class="form-control"
                  id="searchInput"
                  placeholder="Search Name"
                  style="height: 36px;"
                >
              </div>
            </div>
            <div style="overflow: auto;">
              <table class="table">
                <thead>
                  <tr>
                    <th
                      v-for="field in sortableFields"
                      :key="field"
                      @click="sort(field)"
                      :class="{ 'sort-icon': sortKey === field }"
                    >
                      {{ field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' ') }}
                      <span>
                        <i :class="getSortIcon(field)" v-if="field !== 'days_left'"></i>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(terminal, index) in filteredAndSortedTerminals" :key="index">
                    <td v-for="field in sortableFields" :key="`${field}-${terminal.terminal_code}-${index}`">
                      <template v-if="field !== 'days_left'">
                        {{ field === 'expiry_date' ? formatDate(terminal[field]) : terminal[field] }}
                      </template>
                      <template v-else>
                        {{ terminal[field] }}
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HTTPRequest from '../controllers/httpRequest.js';
import moment from 'moment';

export default {
  data() {
    return {
      terminals: [],
      sortKey: 'account_name',
      sortOrder: 'asc',
      searchTerm: '',
      sortableFields: [
        'account_name',
        'site_name',
        'terminal_name',
        'terminal_code',
        'expiry_date',
        'days_left'
      ],
      dataValue: ''
    };
  },
  async mounted() {
    this.dataValue = this.$route.params.param
    await this.fetchTerminals();
  },
  computed: {
    ...mapState(['endPoint']),
    filteredAndSortedTerminals() {
      const searchTerm = this.searchTerm.toLowerCase();
      const searchFields = ['site_name', 'account_name', 'terminal_name'];

      return this.terminals
        .filter(terminal =>
        searchFields.some(field => (terminal[field] ? terminal[field].toLowerCase() : '').includes(searchTerm))
        )
        .sort((a, b) => {
          const valueA = a[this.sortKey];
          const valueB = b[this.sortKey];

          if (valueA && valueB) {
    if (this.sortOrder === 'asc') {
      return valueA.localeCompare(valueB);
    } else {
      return valueB.localeCompare(valueA);
    }
  }

  // Handle null or undefined values
  if (valueA === valueB) {
    return 0;
  } else if (valueA === null || valueA === undefined) {
    return 1;
  } else {
    return -1;
  }
        });
    }
  },
  methods: {
    async fetchTerminals() {
      try {
        const endpointMapping = {
          '365': 'expiry_date_365',
          '90': 'expiry_date_90',
          '60': 'expiry_date_60',
          '30': 'expiry_date_30'
        };

        const days = endpointMapping[this.dataValue];

        if (!days) {
          console.error('Invalid dataValue:', this.dataValue);
          return;
        }

        const response = await HTTPRequest.getRequest(this.endPoint + 'accounts/' + days, null);
        this.terminals = response.near_expiry;
      } catch (error) {
        console.error('Failed to fetch terminals:', error);
      }
    },
    getSortIcon(field) {
      if (this.sortKey === field) {
        return this.sortOrder === 'asc' ? 'fas fa-sort-up active-sort' : 'fas fa-sort-down active-sort';
      } else {
        return 'fas fa-sort';
      }
    },
    formatDate(date) {
      return moment(date).format('MM/DD/YYYY');
    },
    sort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    }
  }
};
</script>
<style>
.active-sort{
  color: #18b313;
}
</style>